import * as React from "react";
import { SVGProps } from "react";

const SilverTierLarge = (
  props: SVGProps<SVGSVGElement> & { bgcolor?: string }
) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 73 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.8068 36.1573L61.8068 40.2747C61.8068 54.3685 50.4842 65.6911 36.3903 65.6911C22.2965 65.6911 10.9739 54.3685 10.9739 40.2747L10.9739 36.1573H61.8068Z"
      fill="#A5C0DB"
    />
    <path
      d="M54.5857 54.5858C44.5368 64.6348 28.2442 64.6348 18.1952 54.5858C8.1462 44.5368 8.1462 28.2442 18.1952 18.1953C28.2442 8.1463 44.5368 8.1463 54.5857 18.1953C64.6347 28.2442 64.6347 44.5368 54.5857 54.5858Z"
      fill="#D1E5F7"
    />
    <path
      d="M48.4938 48.4951C41.8092 55.1796 30.9714 55.1796 24.2869 48.4951C17.6023 41.8105 17.6023 30.9727 24.2869 24.2881C30.9714 17.6036 41.8092 17.6036 48.4938 24.2881C55.1783 30.9727 55.1783 41.8105 48.4938 48.4951Z"
      fill="#F19520"
    />
    <path
      d="M10.6602 36.3112C10.6602 50.5789 22.1224 62.0411 36.39 62.0411C47.2912 62.0411 56.5892 55.3081 60.3565 45.7696C52.1005 47.1322 41.52 45.5291 31.1799 40.4793C23.4049 36.712 17.1527 31.7424 12.7442 26.372C11.3816 29.498 10.6602 32.7844 10.6602 36.3112Z"
      fill="#D0E4F4"
    />
    <path
      d="M48.4938 48.4951C41.8092 55.1796 30.9714 55.1796 24.2869 48.4951C17.6023 41.8105 17.6023 30.9727 24.2869 24.2881C30.9714 17.6036 41.8092 17.6036 48.4938 24.2881C55.1783 30.9727 55.1783 41.8105 48.4938 48.4951Z"
      fill="#A5C0DB"
    />
    <path
      d="M22.2837 26.6119C25.009 24.6882 28.3755 23.566 31.9825 23.6462C41.4408 23.6462 49.0556 31.2609 49.0556 40.7193C49.0556 44.2461 47.9334 47.6126 46.0898 50.4181C50.5786 47.3722 53.5443 42.1621 53.4641 36.3107C53.4641 26.8524 45.8494 19.2376 36.391 19.2376C30.6199 19.2376 25.4098 22.2034 22.2837 26.6119Z"
      fill="#85A8CB"
    />
    <path
      opacity="0.2"
      d="M36.4124 19.2269C33.0943 19.2268 30.4045 17.2982 30.4045 14.9192C30.4046 12.5402 33.0945 10.6117 36.4125 10.6118C39.7306 10.6118 42.4204 12.5405 42.4204 14.9195C42.4203 17.2985 39.7305 19.227 36.4124 19.2269Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M36.4124 62.0294C33.0943 62.0293 30.4045 60.1007 30.4045 57.7217C30.4046 55.3427 33.0944 53.4142 36.4125 53.4143C39.7306 53.4143 42.4204 55.3429 42.4204 57.7219C42.4203 60.1009 39.7305 62.0294 36.4124 62.0294Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M36.3805 14.7019C34.8154 14.7019 33.5466 13.7883 33.5466 12.6614C33.5467 11.5345 34.8155 10.621 36.3806 10.6211C37.9457 10.6211 39.2145 11.5346 39.2145 12.6615C39.2145 13.7884 37.9456 14.7019 36.3805 14.7019Z"
      fill="white"
    />
    <path
      d="M35.1369 29.3227C35.4762 28.5614 36.5567 28.5614 36.8961 29.3227L38.6104 33.1686C38.7503 33.4825 39.047 33.6981 39.3889 33.7342L43.5763 34.1761C44.4051 34.2636 44.739 35.2912 44.1199 35.8492L40.992 38.668C40.7366 38.8981 40.6233 39.2469 40.6946 39.5832L41.5683 43.7022C41.7412 44.5175 40.867 45.1526 40.1451 44.7362L36.4976 42.6325C36.1998 42.4608 35.8331 42.4608 35.5353 42.6325L31.8879 44.7362C31.1659 45.1526 30.2918 44.5175 30.4647 43.7022L31.3383 39.5832C31.4097 39.2469 31.2963 38.8981 31.041 38.668L27.9131 35.8492C27.2939 35.2912 27.6278 34.2636 28.4567 34.1761L32.6441 33.7342C32.9859 33.6981 33.2826 33.4825 33.4226 33.1685L35.1369 29.3227Z"
      fill="url(#paint0_radial_6380_399)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_6380_399"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.6177 33.1539) rotate(116.952) scale(13.248)"
      >
        <stop stop-color="#E9F5FF" />
        <stop offset="0.663462" stop-color="#D0E4F4" />
      </radialGradient>
    </defs>
  </svg>
);
export default SilverTierLarge;
